module.exports = __webpack_public_path__ + "static/media/logo-kind.0a78ceb8.png";